import React from "react";

const Arthrosamid = () => {
	return (
		<>
			<section>
				<h1>Pre-Administration Patient Information</h1>
				<h2>Consent Form</h2>
				<h3>ARTHROSAMID</h3>
				<p>
					The purpose of this document is to provide written information
					regarding the risks, benefits and alternatives of/to Arthrosamid
					injections for knee Osteoarthritis. This is supplementary to the
					discussion you have had with the doctor. It is important you fully
					understand this information so please read this document carefully.
				</p>

				<h4>WHAT IS A KNEE INJECTION?</h4>
				<p>
					Knee injections are often recommended for the treatment of pain and
					inflammation in and around the knee joint.
				</p>

				<h4>PROPOSED INTERVENTION</h4>
				<p>
					Arthrosamid is hydrogel injection administered by ultrasound guidance
					for symptomatic knee osteoarthritis. The hydrogel itself does not
					degrade and therefore it provides long-lasting relief, improving your
					quality of life. In clinical trials, patients reported a significant
					reduction in their pain symptoms by week 4 after their injection and,
					unlike other injectable treatments, the level of reduction was
					maintained at the 3 year follow up period.
				</p>

				<h4>DISCLOSURE</h4>
				<p>
					Before undergoing one of these procedures, understanding the
					associated risks is essential. No procedure is risk-free. The
					following risks are well recognised, but there may also be risks not
					included in this list that are unforeseen by the doctors.
				</p>
				<p>
					This is a new treatment with early promising results. Arthrosamid is a
					device and not a medicine. It has received the appropriate CE marking.
				</p>
				<p>
					As this procedure has not yet been fully assessed by the National
					Institute for Health and Care Excellence (NICE). Your surgical team
					will therefore ask you to complete a short questionnaire prior to and
					following your treatment to monitor your response.
				</p>

				<h4>INTENDED BENEFITS:</h4>
				<p>
					Arthrosamid® is approved for the symptomatic treatment of knee
					osteoarthritis so any patient with this condition may be suitable.
					Over the last 13 years many patients have benefitted from treatment
					with the hydrogel in Arthrosamid®. Typical Symptoms include pain,
					stiffness, swelling and physical function.
				</p>
			</section>

			<section>
				<h2>ALTERNATIVE TREATMENT OPTIONS:</h2>
				<p>
					Given that this is a novel treatment we wish to confirm that all
					appropriate treatments have been explored. These may include:
				</p>
				<ul>
					<li>Physiotherapy course</li>
					<li>Activity modification</li>
					<li>Weight management</li>
					<li>Analgesia</li>
					<li>
						Steroid/hyaluronic acid injection/platelet rich plasma (PRP)
						injection
					</li>
					<li>Mechanical aids such as bracing</li>
				</ul>
				<p>
					Surgery may be an alternative, and may remain a possible option should
					the hydrogel injection not help.
				</p>

				<h3>NO INTERVENTION:</h3>
				<p>
					Not having the injection is a reasonable option, and if you are in any
					doubt then you are advised not undergo this treatment.
				</p>

				<h3>BEFORE THE PROCEDURE:</h3>
				<p>
					As Arthrosamid is a device and not a medicine and given the injection
					is permanent it is therefore important that 1-2 hours before the
					injection oral antibiotics must be taken to reduce the risk of
					developing an infection.
				</p>
				<ul>
					<li>Please inform the doctor of any known allergies;</li>
					<li>Please bring a list of your current medications with you;</li>
					<li>
						You should take your medication as normal. If you are taking
						anticoagulant medication you may be given special instructions;
					</li>
					<li>You may eat and drink as normal;</li>
					<li>
						Your doctor will discuss the procedure with you and ask you to sign
						a consent form;
					</li>
					<li>
						If there is any possibility that you may be pregnant, please inform
						the doctor or nurse.
					</li>
				</ul>

				<h3>THE PROCEDURE:</h3>
				<ul>
					<li>
						The procedure is carried out in one of the clinic treatment rooms;
					</li>
					<li>You will be asked to sit or lie on a hospital couch;</li>
					<li>
						The doctor will clean your skin with an antiseptic solution which
						may feel cold;
					</li>
					<li>
						A local anaesthetic will be injected with a fine needle. This may
						sting initially before the skin goes numb.
					</li>
				</ul>
			</section>

			<section>
				<h2>Contraindications</h2>
				<ul>
					<li>
						If a small dressing has been placed over the needle insertion site.
						This can be removed in the evening.
					</li>
				</ul>

				<h3>CAN EVERYONE HAVE THIS TREATMENT?</h3>
				<p>
					Arthrosamid® may not be suitable for everyone. Your doctor is the best
					person to advise you, but situations where you should not use
					Arthrosamid® (contraindications) include:
				</p>
				<ul>
					<li>You have a temperature</li>
					<li>If you have haemophilia or take anticoagulant treatment</li>
					<li>If you have had a knee arthroscopy within the past 6 months</li>
					<li>Very unstable joint</li>
					<li>
						If you have active skin disease or infection is present at or near
						the injection site
					</li>
					<li>If your joint is infected or severely inflamed</li>
					<li>
						If a degradable intra-articular injectable such as hyaluronic acid
						is present, it must be expected to be absorbed according to
						manufacturer's information for the specific product, before
						injection with Arthrosamid®
					</li>
					<li>
						If you have has previously received treatment with a different
						non-absorbable injectable/implant
					</li>
					<li>
						If you have received a knee alloplasty or has any foreign material
						in the knee
					</li>
				</ul>
				<p>
					Additionally, your doctor may advise you not to have treatment with
					Arthrosamid® if your diabetes is poorly controlled, you are having
					major dental work, or you have been diagnosed with an autoimmune
					disorder, (such as Multiple Sclerosis, Addison's, or Coeliac disease).
					If you are under 18, pregnant, breastfeeding, or have a foreign body
					in your knee, your doctor may advise against the injection.
				</p>
				<p>
					PLEASE TELL THE DOCTOR IF YOU HAVE ANY ALLERGIES OR HAVE EVER HAD A
					REACTION TO A MEDICATION.
				</p>
			</section>

			<section>
				<h2>Risks</h2>
				<p>
					No procedure is risk free. Sterile techniques are always used, which
					helps to reduce this risk.
				</p>

				<h3>Summary Key risks include:</h3>
				<ul>
					<li>Non-efficacy (the treatment may not work)</li>
					<li>
						Short lived efficacy (the treatment may work for a limited time)
					</li>
					<li>Joint infection</li>
					<li>
						Allergic reaction to Antibiotics, local anaesthetic, preservatives
						or to the hydrogel itself.
					</li>
					<li>
						Post injection flare: Injection-related mild to moderate pain and/or
						mild swelling during the first few days to weeks following the
						injection may occur
					</li>
					<li>Swelling of Baker's cyst may also occur</li>
					<li>Worsening of symptoms</li>
					<li>Bleeding/bruising</li>
				</ul>
				<p>Please feel free to discuss these with your treating doctor.</p>

				<h3>AFTER THE PROCEDURE:</h3>
				<p>
					You should avoid any strenuous weight-bearing activities (e.g.
					running, tennis or long walks) during the first few days after your
					injection. Your doctor will be able to advise you on how to slowly
					introduce more activity.
				</p>
				<ul>
					<li>After the procedure you may need to rest for 20-30 minutes;</li>
					<li>
						You are advised to avoid driving after the injection, on the day of
						treatment.
					</li>
					<li>
						The injected knee can feel uncomfortable once the local anaesthetic
						has worn off.
					</li>
					<li>Take your regular medication and pain killers as normal.</li>
					<li>
						If after the injection your knee becomes red, hot, swollen or more
						painful please call the clinic.
					</li>
				</ul>
				<p>
					Patients can start to notice a gradual improvement in symptoms after
					about 10 days. However the majority of patients take longer to see the
					effect of the treatment. Pain levels and function improve for up to 6
					months following the treatment and should last multiple years.
				</p>
				<p>
					Please note if in the future you require a major surgical or dental
					procedure, you should tell your treating physician that you have an
					Arthrosamid® implant in your knee to ensure an accurate medical
					assessment.
				</p>
			</section>

			<section>
				<h2>FURTHER INFORMATION</h2>
				<p>
					If you have any questions or would like further information, please
					speak with your clinician.
				</p>

				<h3>CONFIRMATION OF REFLECTION</h3>
				<p>
					It is important before undergoing any non-emergency treatment that you
					have time to:
				</p>
				<ul>
					<li>Reflect upon the information provided</li>
					<li>Consider other treatment options</li>
					<li>Speak to friends and family</li>
					<li>Ask any follow up questions you may have</li>
				</ul>

				<h3>HOW EFFECTIVE IS THE TREATMENT:</h3>
				<p>
					Like most medical treatments every patient responds slightly
					differently. Younger patients with less severe arthritis seem to
					respond better to the injection. Over all 73% of patients felt that a
					single injection of Arthrosamid significantly improved their symptoms.
					This number is slightly higher in the under 70s (80%) and slightly
					lower in the over 70s (63%).
				</p>

				<h3>FOLLOW UP</h3>
				<p>
					We are very keen to monitor your progress, and understand how you
					respond to the treatment. For this reason, we will contact you at time
					points after the injection to find out how you are doing. This may
					involve follow up appointments, video consultation of possible
					telephone assessments, and on line questionnaires. There is no
					obligation to take part, but we would encourage your participation.
				</p>
			</section>

			<section>
				<h2>RESEARCH AND DATA USAGE:</h2>
				<p>
					We are committed to advancing medical knowledge and improving
					treatments for knee osteoarthritis. As part of this commitment, we may
					use pseudonymised data from your treatment for research purposes.
				</p>
				<p>
					<strong>What this means:</strong>
				</p>
				<ul>
					<li>
						Your personal information (name, address, etc.) will be removed and
						replaced with a unique code
					</li>
					<li>
						Only authorized researchers will have access to this pseudonymized
						data
					</li>
					<li>
						The research will focus on treatment outcomes and effectiveness
					</li>
					<li>You will not be identifiable in any published research</li>
					<li>
						You can withdraw your consent for research data usage at any time
					</li>
				</ul>
				<p>
					This research helps us understand how different patients respond to
					treatment, which ultimately leads to better care for future patients.
					Your participation in research is completely voluntary and will not
					affect your treatment in any way.
				</p>
				<p>
					If you have any questions about how your data might be used for
					research, please discuss this with your doctor before signing this
					consent form.
				</p>
			</section>

			<section>
				<h3>CONSENT:</h3>
				<p>
					My consent and authorization for this elective procedure is strictly
					voluntary. By signing this informed consent form, I hereby grant
					authority to the practitioner to perform injections to area(s)
					discussed during our consultation. I have read this informed consent
					and certify I understand its contents in full. All of my questions
					have been answered to my satisfaction and I consent to the terms of
					this agreement. I agree to adhere to all safety precautions and
					instructions after the treatment. I have been instructed in and
					understand post treatment instructions. I understand and acknowledge
					that no guarantee has been given or implied by anyone as to the
					results that may be obtained by this treatment. I also understand this
					procedure is "elective" and not covered by insurance and that payment
					is my responsibility. Payment is expected in full at the time of
					treatment and is non-refundable
				</p>

				<p>
					I have been informed of the possibility of complications as detailed
					above. If you are happy to proceed and have no further questions
					please sign and date below
				</p>

				<p>
					I understand that any procedure in addition to those described on the
					form will only be carried out if its necessary to save my life or
					prevent serious harm to my health.
				</p>
			</section>
		</>
	);
};

export default Arthrosamid;
